module.exports = __webpack_public_path__ + "img/commission1.964d4ede.webp";